var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"page-title-box d-flex justify-content-between"},[_c('h4',{staticClass:"mb-0 font-size-18"},[_vm._v(_vm._s(_vm.t('Downloads')))])])])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }